module.exports = __webpack_public_path__ + "static/media/icon-dashboard-lead-distributed.364d9b5a.svg";